module.exports = __webpack_public_path__ + "static/media/icon-invite.a07a7878.svg";